import { useContext } from "react";
import { motion } from "framer-motion";
import { dataContext } from "../../context/context";
import './header.css';
import logowhite from "../../assets/images/logo-white.svg";

function HeaderDesktop() {

    const { data, isBY, isRU, isLocal  } = useContext(dataContext);


return (
        <motion.header

            initial={{ opacity: 0, y: -100, }}
            animate={{ opacity: 1, y: 0  }}
            transition={{ duration: 1 }}

        >
            <div className="header__inner">
            <div className="logo"><img alt="Франшиза Суши бар Тунец" src={logowhite} /></div>
            <ul><nav>
                {

                data.sectionsdata.filter((mainsection) => mainsection.parentid === 1)?.map(section => (
                    <li key={section.id}>
                        <a key={section.id} href={`/#${section.nick}`}>
                            {section.name}
                        </a>
                    </li>
                ))
                }
            </nav></ul>
                <div className="phones">
                    {
                        data.variablesdata.filter(variable => variable.var === 'phone').map((phone, index) => (
                            <a key={index} href={`tel: ${phone.clearedval}`}>{phone.val}</a>
                        ))
                    }
                </div>
                <div className="countries">

                    <a className={isRU || isLocal ? "active" : ""} href="https://xn----8sba1acc8awgun9bg.xn--p1ai/">Россия</a>
                    <a className={isBY ? "active" : ""} href="https://xn----8sba1acc8awgun9bg.xn--90ais/">Беларусь</a>

                </div>
            </div>
        </motion.header>
    )
}

export default HeaderDesktop;